module.exports = __webpack_public_path__ + "img/bg_news.25988900.jpg";